<template>
  <div>
    <b-navbar variant="faded" type="light">
      <b-navbar-brand tag="h1" class="mb-0 navBrand">OMEGA ALPHA <img class="logoNav" src="../assets/logo.png" alt=""></b-navbar-brand>

      <b-navbar-nav class="ms-auto">
        <a class="socialLink" href="https://twitter.com/omega_alpha_nft" target="_blank"><b-icon class="twitterIcon" font-scale="2" icon="twitter"></b-icon></a>
        <a class="socialLink" href="https://discord.gg/omega-alpha" target="_blank"><b-icon class="discordIcon" font-scale="2" icon="discord"></b-icon></a>
      </b-navbar-nav>
    </b-navbar>
    <br><br>
    <Mint/>
    <br><br>
    <br><br>

    <Footer/>
  </div>
</template>

<script>
import Team from './homeComp/Team.vue'
import Footer from './homeComp/Footer.vue'
import Mint from './homeComp/Mint.vue'
export default {
  components:{
    Team,
    Footer,
    Mint
  }
}
</script>

<style scoped>
.imgSize
{
  width: 100%;
}
.alphaDetails
{
  width: 50%;
}
.logoNav
{
  width: 5vh;
}
.navBrand
{
  margin-left: 5vh;
    font-weight: 700;
    background: linear-gradient(180deg, rgba(255,237,101,1) 20%, rgba(215,148,61,1) 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent; 
    -moz-text-fill-color: transparent;
}
.socialLink
{
  margin-left: 2vh;
  margin-right: 2vh;
}
.twitterIcon
{
  color: #1DA1F2;
}
.discordIcon
{
  color: #5865F2;
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue